import axios from 'axios';

export function findVesselDesign(name) {
    return axios({
        method: 'post',
        url: '/api/v1/vesselDesign/find',
        data: {
            name,
        },
        withCredentials: true,
    });
}


// WEBPACK FOOTER //
// ./app/services/design.js